export default function _typeof(obj) {
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};
